import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import { ModalScreen } from "../../../components/ModalScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ModalSCScreens from "../../Modales/ModalSCScreens";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

export const ModalSolicitudCreditoJDF = ({
    open,
    setOpenSolicitud,
    value,
    upload,
    setValue,
    maxValue,
    screens,
    titulos,
    estado,
    // { screen0: boolean, ... } de TimelineHelper.js. Opcional: sin dato, se
    // trata como habilitado.
    pasosHabilitados = {},
}) => {
    const [titulo, setTitulo] = useState("");
    // Overrides locales (ej. "acabo de aceptar este paso") que no dependen de
    // recargar data/estado del padre; evita cerrar el modal por un upload().
    const [pasosHabilitadosLocal, setPasosHabilitadosLocal] = useState({});

    // Se limpia cada vez que el modal (re)abre, para no arrastrar overrides
    // de una sesión anterior.
    useEffect(() => {
        setPasosHabilitadosLocal({});
    }, [open]);

    // Marca el paso siguiente al actual como habilitado (sin recargar nada).
    const habilitarSiguiente = () => {
        const clave = `screen${Number(value) + 1}`;
        setPasosHabilitadosLocal((prev) => ({ ...prev, [clave]: true }));
    };

    // Indica si el paso "paso" (índice de pantalla) puede visitarse.
    const estaHabilitado = (paso) => {
        const clave = `screen${Number(paso)}`;
        if (pasosHabilitadosLocal[clave] === true) return true;
        if (pasosHabilitados[clave] === undefined) return true;
        return pasosHabilitados[clave] === true;
    };

    const onSiguiente = () => {
        const siguienteValor = Number(value) + 1;
        if (
            maxValue === undefined ||
            maxValue === null ||
            typeof maxValue !== "number" ||
            Number(maxValue) <= Number(value)
        ) {
            setOpenSolicitud(false);
            upload();
            return;
        }
        if (!estaHabilitado(siguienteValor)) {
            Swal.fire(
                "PROCESO NO DISPONIBLE",
                "Aún no es posible avanzar a este paso. Complete el proceso actual antes de continuar.",
                "warning"
            );
            return;
        }
        setValue(siguienteValor);
    };
    const onRegresar = () => {
        if (
            maxValue === undefined ||
            maxValue === null ||
            typeof maxValue !== "number"
        ) {
            setOpenSolicitud(false);
            return;
        }
        if (Number(value) === 0) {
            setOpenSolicitud(false);
            upload();
            return;
        }
        const anteriorValor = Number(value) - 1;
        if (!estaHabilitado(anteriorValor)) {
            Swal.fire(
                "PROCESO NO DISPONIBLE",
                "Aún no es posible regresar a este paso.",
                "warning"
            );
            return;
        }
        setValue(anteriorValor);
    };
    useEffect(() => {
        var titulo = titulos[`screen${Number(value)}`];
        if (Element === undefined || Element === null) setTitulo("NO DEFINIDO");
        else setTitulo(titulo);
    }, [value]);
    if (
        open === undefined ||
        open === null ||
        typeof open !== "boolean" ||
        open === false
    ) {
        return;
    }

    // Cerrar/finalizar siempre se permite; navegar depende de pasosHabilitados.
    const esUltimoPaso =
        maxValue === undefined ||
        maxValue === null ||
        typeof maxValue !== "number" ||
        Number(maxValue) <= Number(value);
    const siguienteHabilitado = esUltimoPaso || estaHabilitado(Number(value) + 1);

    const esPrimerPaso =
        Number(value) === 0 ||
        maxValue === undefined ||
        maxValue === null ||
        typeof maxValue !== "number";
    const anteriorHabilitado = esPrimerPaso || estaHabilitado(Number(value) - 1);

    return (
        <ModalScreen close={setOpenSolicitud} upload={upload}>
            <span className="filtro-soy-span-close"
                onClick={() => {
                    setOpenSolicitud(false)
                    upload()
                }
                }
            >
                X
            </span>
            <PlantillaScreen titulo={titulo} className={"asc-modal-jdf-condicionado"}>
                <div className="analisis-as-screen-container scroll">
                    <ModalSCScreens
                        value={value}
                        screens={screens}
                        extraProps={{ habilitarSiguiente }}
                    />
                </div>
                <div className="analisis-as-screen-footer">
                    <div
                        className={
                            anteriorHabilitado
                                ? "analisis-as-screen-regresar"
                                : "analisis-as-screen-regresar analisis-as-screen-regresar-disabled"
                        }
                        onClick={() => onRegresar()}
                    >
                        <ArrowBackIcon />
                        {Number(value) === 0 ? "Regresar" : "Anterior"}
                    </div>

                    {/* {estado.precalificacion !== "X" && (
                        <div
                            className="analisis-as-screen-siguiente"
                            onClick={() => onSiguiente()}
                        >
                            {Number(value) < Number(maxValue) ? "Siguiente" : "Finalizar"}
                            <ArrowForwardIcon />
                        </div>
                    )} */}

                    <div
                        className={
                            siguienteHabilitado
                                ? "analisis-as-screen-siguiente"
                                : "analisis-as-screen-siguiente analisis-as-screen-siguiente-disabled"
                        }
                        onClick={() => onSiguiente()}
                    >
                        {Number(value) < Number(maxValue) ? "Siguiente" : "Finalizar"}
                        <ArrowForwardIcon />
                    </div>

                </div>
            </PlantillaScreen>
        </ModalScreen >
    );
};
